import { useNavigate, useSearchParams } from "react-router-dom";
import LawnetLogo from "../../../assets/images/LAWNET LOGO.png";
import successGif from "../../../assets/images/paymentSuccess.gif";
import failedGif from "../../../assets/images/paymentFailed.gif";
const PaymentResponse = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const refNo = searchParams.get("ref");
  return (
    <div className="payment-body">
      <div className="payment-container">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img height={60} src={LawnetLogo} alt="" />
        </div>
        <div className={`message-box ${status === "1" ? "success" : "failed"}`}>
          {status === "1" ? (
            <>
              <img src={successGif} alt="Success" className="gif" />
              <h2>Payment Successful!</h2>
            </>
          ) : (
            <>
              <img src={failedGif} alt="Success" className="gif" />
              <h2>Payment Failed</h2>
            </>
          )}

          <p>
            Reference No: <strong>{refNo || "N/A"}</strong>
          </p>
          <button
            onClick={() => {
              if (refNo.startsWith("WOD")) {
                navigate("/eWarta/purchaseHistory");
              } else {
                navigate("/login");
              }
            }}
            className="login-button"
          >
            Return to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentResponse;
